export const CardIcon = ({
  strokeColor = "var(--color-icon-bright)",
  ...props
}: any) => (
  <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none">
    <path
      d="M18.3332 7.70703H1.6665C1.32484 7.70703 1.0415 7.4237 1.0415 7.08203C1.0415 6.74036 1.32484 6.45703 1.6665 6.45703H18.3332C18.6748 6.45703 18.9582 6.74036 18.9582 7.08203C18.9582 7.4237 18.6748 7.70703 18.3332 7.70703Z"
      fill={strokeColor}
    />
    <path
      d="M6.66667 14.375H5C4.65833 14.375 4.375 14.0917 4.375 13.75C4.375 13.4083 4.65833 13.125 5 13.125H6.66667C7.00833 13.125 7.29167 13.4083 7.29167 13.75C7.29167 14.0917 7.00833 14.375 6.66667 14.375Z"
      fill={strokeColor}
    />
    <path
      d="M12.0833 14.375H8.75C8.40833 14.375 8.125 14.0917 8.125 13.75C8.125 13.4083 8.40833 13.125 8.75 13.125H12.0833C12.425 13.125 12.7083 13.4083 12.7083 13.75C12.7083 14.0917 12.425 14.375 12.0833 14.375Z"
      fill={strokeColor}
    />
    <path
      d="M14.6332 17.7096H5.3665C2.04984 17.7096 1.0415 16.7096 1.0415 13.4263V6.5763C1.0415 3.29297 2.04984 2.29297 5.3665 2.29297H14.6248C17.9415 2.29297 18.9498 3.29297 18.9498 6.5763V13.418C18.9582 16.7096 17.9498 17.7096 14.6332 17.7096ZM5.3665 3.54297C2.74984 3.54297 2.2915 3.99297 2.2915 6.5763V13.418C2.2915 16.0013 2.74984 16.4513 5.3665 16.4513H14.6248C17.2415 16.4513 17.6998 16.0013 17.6998 13.418V6.5763C17.6998 3.99297 17.2415 3.54297 14.6248 3.54297H5.3665Z"
      fill={strokeColor}
    />
  </svg>
);
